
import { Component, Prop, Vue } from 'vue-property-decorator'
import PreViewBase from './preview/base.vue'
import PreViewTemp1 from './preview/temp1/index.vue'

@Component({
  name: 'mobile-view',
  components: {
    PreViewBase,
    PreViewTemp1
  }
})

export default class MobileView extends Vue {
  @Prop({ type: String, default: 'PreViewBase' })
  private componentId!: string

  @Prop({ type: [Object, Array] })
  private data!: object|any

  @Prop({ type: Array })
  private instrs!: any[]

  public updateData (data: any) {
    this.data = data
  }

  public updateDataTnstrs (instrs: any) {
    this.instrs = instrs
  }
}
